import styles from './Avatar.module.scss';

import cn from 'classnames';

import type { HTMLAttributes } from 'react';
import { useState } from 'react';

import EmptyUser from './images/empty_user.svg';

export const Avatar = (
  props: HTMLAttributes<HTMLImageElement> & {
    _id: string;
    isLoading?: boolean;
    src?: string;
  },
) => {
  const [isDefaultImage, setDefaultImage] = useState(false);

  const version = Date.now(); // this needs to clear browser cache
  const imageSrc = props.src
    ? props.src
    : `${import.meta.env.VITE_S3_AVATARS_URL}${props._id}.jpg?v=${version}`; // todo remove than make normal image urls

  return (
    <span
      className={cn(styles.wrapper, {
        skeleton: props.isLoading,
        skeletonAutoHeight: props.isLoading,
      })}
    >
      {!props.isLoading && (
        <img
          className={cn(
            styles.avatar,
            props.className,
            isDefaultImage && !props.src && 'defaultImage',
          )}
          src={imageSrc}
          alt="user"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = EmptyUser;
            setDefaultImage(true);
          }}
        />
      )}
    </span>
  );
};
